export function getCurrentLanguage() {
  return navigator.language; //TODO usar el selector de redux de idioma
}
